module.exports = __webpack_public_path__ + "img/9a98726.jpg";